module.exports = __webpack_public_path__ + "img/404_cloud.a57b6f31.png";